import * as t from 'io-ts';

export const NotificationEndpointTypeCodec = t.keyof({
  EMAIL: null,
  SMS: null,
});
export type NotificationEndpointType = t.TypeOf<
  typeof NotificationEndpointTypeCodec
>;
export const NotificationEndpointCodec = t.type({
  id: t.string,
  type: NotificationEndpointTypeCodec,
  value: t.string,
  verified: t.boolean,
});
export type NotificationEndpoint = t.TypeOf<typeof NotificationEndpointCodec>;
export type NotificationEndpointSave = Pick<
  NotificationEndpoint,
  'type' | 'value'
>;
